import { FieldType } from '@ngx-formly/core';
import { Component } from '@angular/core';

@Component({
  selector: 'em-formly-chips',
  templateUrl: './chips.component.html'
})
export class ChipsTypeComponent extends FieldType {
}
